var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSearch = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 41,
  height: 41,
  viewBox: "0 0 41 41",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20.5,
  cy: 20.5,
  r: 20.5,
  fill: "white"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24.2193 22.7323H23.4372L23.16 22.465C24.1302 21.3364 24.7144 19.8711 24.7144 18.2771C24.7144 14.7228 21.8333 11.8418 18.2791 11.8418C14.7248 11.8418 11.8438 14.7228 11.8438 18.2771C11.8438 21.8314 14.7248 24.7124 18.2791 24.7124C19.873 24.7124 21.3383 24.1283 22.467 23.158L22.7343 23.4353V24.2174L27.6845 29.1577L29.1597 27.6826L24.2193 22.7323V22.7323ZM18.2791 22.7323C15.8138 22.7323 13.8238 20.7423 13.8238 18.2771C13.8238 15.8119 15.8138 13.8219 18.2791 13.8219C20.7443 13.8219 22.7343 15.8119 22.7343 18.2771C22.7343 20.7423 20.7443 22.7323 18.2791 22.7323Z",
  fill: "#010B3B"
})));

const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search.86679379563d8d4aafd16b80147bf984.svg";